module.exports = __webpack_public_path__ + "static/Logo_03-a4f5f6f62c74e5742273eefe319d7f4e.png";